import React from 'react';
import { CanvasImage } from 'remotion';
import instagramStoryUi from '../assets/ig-story-ui.svg';

export const SocialSafeZones: React.FC = () => {
	return (
		<div
			style={{
				height: 1920,
				left: 0,
				pointerEvents: 'none',
				position: 'absolute',
				top: 0,
				width: 1080,
				zIndex: 2147483647,
			}}
		>
			<CanvasImage
				aria-hidden="true"
				fit="contain"
				height={1920}
				showInTimeline={false}
				src={instagramStoryUi}
				style={{
					height: '100%',
					left: 0,
					position: 'absolute',
					top: 0,
					width: '100%',
				}}
				width={1080}
			/>
		</div>
	);
};
